import { makeStyles } from "@material-ui/core";
import { color } from "../../../assets/const/color";
export const useStyles = makeStyles(() => ({
    notifi: {
        "& .MuiInputBase-root": {
            borderRadius: "50px",
            fontFamily: "inter !important",
          },
    "& .MuiCheckbox-colorPrimary.Mui-checked": {
      color: `${color.gray} !important`,
      borderRadius: "50px !important",
    },
    "& .MuiCheckbox-root.MuiCheckbox-indeterminate": {
      color: `${color.gray} !important`,
    },
    "& .MuiTableHead-root": {
      background: "#FEB62C",
      "& .MuiTableCell-root": {
        color: `${color.white} !important`,
        fontFamily: "inter",
      },
      "& :first-child": {
        borderRadius: "10px 0px 0px 0px !important",
      },
      "& :last-child": {
        borderRadius: "0px 10px 0px 0px !important",
      },
    },
    "& .MuiTableRow-root .MuiTableCell-root": {
      fontFamily: "inter !important",
    },
    
  },
  input_label: {
    marginRight:"20px",
  },
  label: {
    color: "#374151",
    fontFamily: "inter !important",
    fontSize: "14px !important",
    fontWeight: "500 !important",
  },
  form_add_course: {
    "& .MuiInputBase-root": {
      borderRadius: "50px",
      fontFamily: "inter !important",
    },
    "& .MuiButton-root:hover": {
      background: `${color.lightGreen} !important`,
      color: `${color.white} !important`,
    },
  },
  heading: {
    display: "flex",
    alignItems: "center",
    fontSize:"20px"
  },
  img_holder: {
    width: "40px",
    // height: "60px",
    "& img": {
      borderRadius: "50px",
    },
  },
  gap: {
    margin: "0 !important",
    fontFamily: "inter !important",
  },
  gaps: {
    fontSize:"16px",
    fontWeight:700,
    margin: "0 !important",
    color: `${color.darkGreen} !important`,
    fontFamily: "inter !important",
  },
  notifiLeft: {
    display:"flex", alignItems:"center", alignItems:"center"
  }
}));
